import { Box, MenuItem, Typography, Select } from "@mui/material";

const CustomComboBox = ({ label, onChange, items = [], value, prefix = "", prefixIndex = 0, error }) => (
  <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 1.5 }}>
    {label && (
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: error ? "#D33A3A" : "var(--text-3)", mb: 0.5 }}>
        {label}
      </Typography>
    )}
    <Select
      size="small"
      value={value ?? ""}
      displayEmpty
      error={Boolean(error)}
      onChange={(e) => {
        const selected = items.find((item) => item.value === e.target.value);
        onChange(e.target.value, selected ? selected.id : undefined);
      }}
      variant="outlined"
      sx={{
        borderRadius: 2,
        backgroundColor: "var(--surface)",
        fontSize: 14,
        "& fieldset": { borderColor: "var(--border)" },
        "&:hover fieldset": { borderColor: "var(--text-3)" },
        "&.Mui-focused fieldset": { borderColor: "#2F4858" },
      }}
    >
      {items.map((item, ind) => (
        <MenuItem key={ind} value={item.value}>
          {item.name + (prefixIndex <= ind ? prefix : "")}
        </MenuItem>
      ))}
    </Select>
  </Box>
);

export default CustomComboBox;
